import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// Remove StrictMode for production performance
const isDevelopment = import.meta.env.DEV;

const root = createRoot(document.getElementById('root'));
root.render(
  isDevelopment ? (
    <StrictMode>
      <App />
    </StrictMode>
  ) : (
    <App />
  )
);